import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

function ContactCollapse() {
  const [toggleMenu, setToggleMenu] = useState<number | null>(null);
  const [questions, setQuestions] = useState<number>();
  const toggle = (index: number) => {
    if (toggleMenu === index) {
      setToggleMenu(null);
    } else {
      setToggleMenu(index);
      const idno = document.getElementById(`questions${index}`);
      if (idno) setQuestions(idno.clientHeight);
    }
  };

  const questionsArr = [
    {
      bgcolor: "#D0E9CF",
      que: "What is the response time for inquiries?",
      ans: "We strive to respond to all inquiries within 24 hours or sooner.",
    },
    {
      bgcolor: "#9BE8ED",
      que: "What are your hours of operation?",
      ans: "Our office is open Monday through Friday from 9:00 AM to 8:00 PM EST and Saturday from 9:00 AM to 5:00 PM EST.",
    },
    {
      bgcolor: "#edcc9b",
      que: "What documents should I upload for a customer inquiry review?",
      ans: "Please upload any relevant pictures, a service repair form, or an invoice to help us address your inquiry efficiently.",
    },
  ];

  return (
    <>
      {questionsArr.map((item, index) => (
        <div
          key={`question-${index}`}
          className={`p-5 rounded-[4px] border-t-[3px] bg-white `}
          style={{
            borderColor: item.bgcolor,
          }}
        >
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggle(index)}
          >
            <p className="text-lg text-black">{item.que}</p>
            <IoIosArrowDown
              className={`text-2xl text-gray-500 transition-transform duration-300 ${
                toggleMenu === index ? "rotate-180" : ""
              }`}
            />
          </div>
          <div
            className="transition-all overflow-hidden"
            style={{ height: toggleMenu === index ? questions : 0 }}
          >
            <div className="pt-5" id={`questions${index}`}>
              <span className="mb-1">{item.ans}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default ContactCollapse;
